import { useCallback, useEffect, useRef, useState } from "react";
import { CommunityCounterModel } from "./models/CommunityCounterModel";
import { getCommunityPartnerCounter } from "../../services/partnerExpertService";

export const useExpertCommunityCounters = (partnerId: number) => {
    const isMountedRef = useRef(true);
    const [loading, setLoading] = useState(false);
    const [counters, setCounters] = useState<CommunityCounterModel>({
        accepted: 0,
        banned: 0,
        declined: 0,
        totalRequests: 0,
        unanswered: 0
    }); 

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        }
    }, []);

    const load = useCallback(async () => {
        try {
            setLoading(true);
            const _result = await getCommunityPartnerCounter(partnerId)
            if(!isMountedRef.current)
                return;
            setCounters(_result);
        }
        finally {
            if(!isMountedRef.current)
                return;
            setLoading(false);
        }
    }, [partnerId]);

    useEffect(() => {
        load();
    }, [load]);

    return { loading, counters }
}